.avatarButton {
  background: none;
  border: none;
  border-radius: 50%;
  padding: 0;
  margin: auto;
  display: flex;
}
.avatarButton :global(.avatar) {
  --local-avatar-vertical-margin: 0;
}